import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

export default class EFOcats_event_accordion extends EFOcats_event_core {
  event() {
    this.$('.js-menu__item__link').on('click', event => {
      const element = event.currentTarget;
      $(element)
        .parents('.qa')
        .find(`.submenu[target-name="${$(element).text().trim()}"]`)
        .slideToggle();
      $(element).toggleClass('menu__item__link_on');
      return false;
    });
  }
}
